import React from "react";
import { Datagrid, List, TextField } from "react-admin";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { SourceHomebaseComponent } from "./Constant/Constant";
import { EnumField } from "../../../Components/EnumField";
import { CustomDateField } from "../../../Components/CustomDateField";

const HomebaseComponentDetail = (props: any) => {
  let pn = props?.record?.pn != null ? props.record.pn : 0;
  let sn = props?.record?.sn != null ? props.record.sn : 0;
  let id = props?.record?.id != null ? props.record.id : 0;
  return (
    <List
      {...props}
      bulkActionButtons={false}
      exporter={false}
      resource={SourceHomebaseComponent}
      filter={{
        pn__eq: pn,
        sn__eq: sn,
        id__neq: id,
      }}
      sort={{ field: "createdDate", order: "DESC" }}
      actions={false}
    >
      <Datagrid>
        <TextField source="refNo" />
        <TextField source="pn" />
        <TextField source="sn" />
        <TextField source="condition" />
        <EnumField label={"Status"} enumName={"HomebaseStatusType"} source={"homebaseStatusEnum"} />
        <CustomDateField label="Used Date" source="updatedDate" showTime />
        <CreatedByField source="createdBy" link={false} />
        <CustomDateField source="createdDate" showTime />
      </Datagrid>
    </List>
  );
};

export default HomebaseComponentDetail;
